module.exports = __webpack_public_path__ + "static/media/sello.d8aaa803.svg";